import { ToastContainer } from "react-toastify";

const ToastContainerWrapper = () => {
  return (
    <>
      {/* This is a workaround to make the toasts appear fixed and above other content */}
      {/* TODO: Remove this once we have a better solution */}
      <style>
        {`
            .Toastify {
            position: fixed !important;
            pointer-events: none;  /* Let clicks pass through the container */
            z-index: 9999;        /* Ensure it's above other content */
            }
            .Toastify__toast {
            pointer-events: auto;  /* Make the actual toasts clickable */
            }
        `}
      </style>
      <ToastContainer
        position="bottom-right"
        closeButton={true}
        icon={false}
        limit={3}
      />
    </>
  );
};

export default ToastContainerWrapper;
